import { Guid } from "@/Common/Models/Guid";
import { ITableDataSourceItem } from "@/Common/Models/UI/Tables/ITableDataSourceItem";
import { LabMessage } from "./LabMessage";

class LabMessageTableItem implements ITableDataSourceItem<LabMessage> {
    public Model: LabMessage;
    public IsSelected: boolean;

    public IsInFocus: boolean;
    public Name: string;

    public ActionByEmployeesContactFacetId: Guid[];
    public StuffedEmployees: string; // EmployeesHowDidAnAction
    public StuffedActions: string; // ActionInboxView
    public IsRedAction: boolean; // Urgent or SemiUrg
    public IsBoldAction: boolean; // Urgent
    public IsCompletedActionInbox: boolean; // Item Returned from a "Get Completed Actions Call"; Item is completed

    public constructor(labMessage: LabMessage) {
        this.Model = labMessage;
        this.IsInFocus = false;
        this.StuffedActions = "";
        this.IsRedAction = false;
        this.IsBoldAction = false;
        this.IsCompletedActionInbox = false;
        this.StuffedEmployees = "";
        this.ActionByEmployeesContactFacetId = [];
        this.IsSelected = false;
    }

    public get isSelectable(): boolean {
        return !this.Model.Model.IsManualLabEntry;
    }
}

export { LabMessageTableItem };
